import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const videoWidget = {
  fetchVideoWidgets: lazyModuleMethod(
    () => import('./fetchVideoWidgets'),
    'default'
  ),
  fetchVideoWidget: lazyModuleMethod(
    () => import('./fetchVideoWidget'),
    'default'
  ),
  updateVideoWidget: lazyModuleMethod(
    () => import('./updateVideoWidget'),
    'default'
  ),
  deleteVideoWidget: lazyModuleMethod(
    () => import('./deleteVideoWidget'),
    'default'
  ),
  createVideoByCode: lazyModuleMethod(
    () => import('./createVideoByCode'),
    'default'
  ),
  updateVideoByCode: lazyModuleMethod(
    () => import('./updateVideoByCode'),
    'default'
  ),
}
